var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { getShape, getColor, getBackgroundColor, getBorderColor } from '../util';
const SvgMegaphone = _a => {
  var {
      size,
      shape = 'circle',
      neutral = false
    } = _a,
    props = __rest(_a, ["size", "shape", "neutral"]);
  const backgroundColor = getBackgroundColor(shape, neutral);
  const color = getColor(shape, neutral);
  const borderColor = getBorderColor(neutral);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 96,
    height: size !== null && size !== void 0 ? size : 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), getShape(shape, backgroundColor), React.createElement("path", {
    fill: color,
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m36.836 65.524-9.422 4.96a12.47 12.47 0 0 1-16.793-5.198c-3.187-6.051-1.789-13.054 5.206-16.794l9.43-4.968 11.58 22Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M36.837 65.524c12.77-6.726 30.177-4.607 36.258-3.609a1.09 1.09 0 0 0 1.145-1.59l-2.673-5.067-9.099-17.277-11.764-22.353a1.098 1.098 0 0 0-1.965.046c-2.596 5.59-10.75 21.132-23.482 27.85l11.58 22Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "m34.94 66.822 2.12 14.59a4.008 4.008 0 0 1-3.356 4.545 4.008 4.008 0 0 1-4.546-3.355l-1.766-11.71"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m34.94 66.822 2.12 14.59a4.008 4.008 0 0 1-3.356 4.545v0a4.008 4.008 0 0 1-4.546-3.355l-1.766-11.71"
  }), React.createElement("path", {
    fill: color,
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M66.146 44.916a7.195 7.195 0 0 0 3.002-9.683 7.187 7.187 0 0 0-9.69-2.964l6.688 12.647Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M49.606 27.66a58.551 58.551 0 0 1-11.38 14.229M35.315 44.202a73.742 73.742 0 0 1-3.455 2.603"
  }), React.createElement("path", {
    stroke: "var(--color-neutral-70)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M20.349 51.464a10.159 10.159 0 0 0-6.143 4.608M62.583 34.573s2.303-.768 3.839.767"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m77.771 29.918 9.26-4.876M63.466 19.998 66.568 10M87.86 50.429l-10.005-3.103"
  }));
};
export default SvgMegaphone;